/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function() {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * A simple model for expressing the app's model state.
   */
  ns.IndicatorSelectionModel = Backbone.Model.extend({
    defaults: {
      locationType: "n",
      location: "n",
      categories: [],
      indicators: []
    }
  });
})(jQuery);
